import { linkOrderToUser } from '../../../services/lwadmin/livewire-events/events-service';

export default class LivewireEventOrder {
  constructor(source) {
    Object.assign(this, source);
  }

  linkToUser(user) {
    return linkOrderToUser(this.id, user.id);
  }
}
